angular.module('gym.mobile_app').directive('mobileAppSettingsProximityCheckin', function() {
  return {
    restrict: 'E',
    template: require('templates/gyms/mobile_app/proximity_checkin.html.slim'),
    scope: {
      setTab: '&'
    },
    controller: ["$scope", "Locations", "ProximityCheckinLocations", function($scope, Locations, ProximityCheckinLocations) {
      Locations.getList({
        count: 1000
      }).then(function(locations) {
        return $scope.eventLocations = locations;
      });
      ProximityCheckinLocations.getList({
        count: 1000
      }).then(function(locations) {
        return $scope.checkinLocations = [
          {
            id: null,
            display_name: 'None selected'
          }
        ].concat(locations);
      });
      $scope.goToLocations = function() {
        return $scope.setTab({
          tab: {
            name: 'event_locations',
            subtab: true
          }
        });
      };
      $scope.goToCheckinAddresses = function() {
        return $scope.setTab({
          tab: {
            name: 'proximity_checkin_addresses',
            subtab: true
          }
        });
      };
      $scope.goToEventDefaults = function() {
        return $scope.setTab({
          tab: {
            name: 'event_defaults',
            subtab: true
          }
        });
      };
      return $scope.updateAddress = function(eventLocation) {
        return eventLocation.save();
      };
    }]
  };
});
